import Viewports from "../fsUtils/Viewports";
import scrollEvent from '../fsUtils/scrollEvent';

class BannerAdsPin {

    constructor() {

        this.bodyClassList = document.body.classList;
        this.cachedScrollYpos = 0;
        this.secNav = document.querySelector('.section-nav');
        this.sidebar = document.querySelector('#sidebar');
        this.isPin = false;
        this.branchBannerHeight = 0;
        this.globalNavH = 44;
        this.unPinPos = 600;
        this.bannerAdSizeAttr = null;
        this.viewports = new Viewports();
        this.winW = this.viewports.winW;
        this.isiPad = this.viewports.isIPad;
        this.viewPort = this.viewports.getViewPort();
        this.rightRailElm = document.querySelector('.right-rail-wrapper .right-rail');
        this.bannerAdContiner = document.getElementById('banner-ad');
        this.bannerOverlay = document.querySelector('.banner-ad-overlay');
        this.allowAdSizes = ["728,90", "980,50", "320,50"];
        this.timer = null;
        this.adTimeLimit = 5000;
        this.isClickedOn3things = false;

        this.styleObj = {
            bannerAdPin: 'banner-ad-pin',
            mobileAdTransform: 'banner-ad-transform',
            rightRailAdTransform: 'right-rail-transform'
        };

        window.addEventListener('dfp.slotRenderEnded', (e) => {
            //data-banner-ad-size attribute is set only after the ad slot is rendered,
            //so we need to access it after the ad slot is rendered
            this.bannerAdSizeAttr = document.querySelector('[data-banner-ad-size]');
            this.init();
        });

    }

    init() {

        if (this.hideNav()) {
            this.bodyClassList.add('hideNav');
        }

        window.addEventListener("scroll", () => {
            scrollEvent.debounce(200, this.onScroll());
        });

        document.body.addEventListener("click", () => {

            //unpin banner ad when users click on outside the banner ad
            if (this.isPin) {
                this.removePin();
            }

        });
    }
    getPromoHeight() {
        let appPromoHeight = 0;
        if (this.bodyClassList.contains('branch-banner-is-active')) {
            appPromoHeight = 76;
        }
        return appPromoHeight;
    }

    getSecNavHeight() {
        return (this.secNav) ? this.secNav.offsetHeight : 0;
    }

    okToPin() {

        let okToPin = true;

        /*
         * we need to select data-banner-ad-size again here because EventListener('dfp.slotRenderEnded') is not triggered
         * on any page that has no additional ad slots beside banner ex: media hub page
         */
        let adEl = (this.bannerAdSizeAttr !== null) ? this.bannerAdSizeAttr : document.querySelector('[data-banner-ad-size]');
        let adSize = adEl && adEl.getAttribute("data-banner-ad-size");
        let isSecNavOpen = this.bodyClassList.contains('secondary-menu-open');
        let excludePageType = this.excludePageType();
        let bannerHeight = (this.bannerAdContiner) ? this.bannerAdContiner.offsetHeight : 0;

        /*
         After Ads are rendered in the page, we update banner-ad-size attribute value in the Dom. See fsAdCollection.setBannerAdSize()
         We don't want to pin the ad if the adSize is empty that means the ad is not created, or if the adSize is 970x250 because it
         take up too much space in the window. We don't want to pin the ad if the second nav is open
         we also don't want to pin the ad on open template because in some open template pages,
         the contents were injected inside the adplaceholderBelowNavigation iparsys
         */

        if (!adSize || bannerHeight > 90 || this.allowAdSizes.indexOf(adSize) === -1 || isSecNavOpen || excludePageType) {
            okToPin = false;
        }
        return okToPin;

    }

    hideNav() {
        return (location.href.indexOf("nav=false") > -1 || document.cookie.indexOf("activeNavCookie=true") > -1) ? true : false;
    }


    excludePageType() {
        let excludePageType = false;
        if (this.bodyClassList.contains('fillnone') || this.bodyClassList.contains('blog-outkick-the-coverage') || this.bodyClassList.contains('story-outkick-the-coverage')) {
            excludePageType = true;
        }

        return excludePageType;
    }

    removePin() {
        this.bodyClassList.remove(this.styleObj.bannerAdPin);
    }
    stopTimer(timer) {
        if (timer) {
            window.clearTimeout(timer);
            timer = null;
        }
    }

    //pin the ad after scrolling position is surpassed the pinPos and un-pin the ad after timeout or scrolling position is less or equal than the pinPos
    triggerScroll(scrollDirection, scrollY) {

        let okToPin = this.okToPin();

        if (okToPin) {

            let pinPos = this.getSecNavHeight();
            let viewPort = this.viewPort;
            pinPos = pinPos + this.getPromoHeight();

            /**
             * pin banner ad when scrollY position passes preset pin position, and scrollY position is less than preset unpin position
             * don't activate ad pin when this.isClickedOn3things is true which means users click on the 3 things on the left rail
             * otherwise; the pinned ad will cover the top of the story on the 3 things
             **/
            if (!this.isPin && scrollDirection === 'down' && scrollY >= pinPos && !this.isClickedOn3things) {

                this.isPin = true;
                this.stopTimer(this.timer);

                this.bodyClassList.add(this.styleObj.bannerAdPin);
                this.bannerOverlay.style.transition = 'none';

                //setTimeout to remove ad pin after 3 seconds
                this.timer = setTimeout(() => {
                    this.bannerOverlay.style.transition = null;
                    if (this.sidebar) this.sidebar.style.transition = null;
                    this.removePin();

                    //checking (if this.cachedScrollYpos - scrollY > 0) to determine if users scroll backup right after scrolling down the page
                    //we don't want to add banner-ad-transform class if users scroll backup to the top of the page within that 5 seconds
                    //otherwise; the banner ad will be moved out from the page content and leave a empty space
                    if (this.cachedScrollYpos - scrollY > 0) {

                        if (viewPort === 'mobile') {
                            this.bodyClassList.add(this.styleObj.mobileAdTransform); //banner-ad-transform class adding the transition for sliding up
                        } else if (this.rightRailElm && this.rightRailElm.style.position === "fixed") {
                            //apply right-rail-transform class if the right rail is pinned (has fixed position).
                            this.bodyClassList.add(this.styleObj.rightRailAdTransform);
                        }

                    }

                }, this.adTimeLimit);
            }

            if (scrollDirection === 'up' && scrollY <= pinPos) {
                this.removePin();
                if (viewPort === 'mobile') {
                    this.bodyClassList.remove(this.styleObj.mobileAdTransform);
                }

                //when users scroll back up, reset this.isPin and this.isClickedOn3things to false
                this.isPin = false;
                this.isClickedOn3things = false;

            }
        }
    }

    onScroll() {
        let isMenuClosed = !this.bodyClassList.contains('global-menu-open') && !this.bodyClassList.contains('section-menu-open') && !this.bodyClassList.contains('scorestrip-open');

        if (isMenuClosed) {

            let scrollYpos = window.pageYOffset;
            let scrollDistance = scrollYpos - this.cachedScrollYpos;
            let scrollDirection = '';

            /*
             * To ensure the scrolling direction is correct, we need to compare the distance that users scroll
             * to avoid down and up directions registered at the same time
             * because users just move the mouse 1px up and down
             * When users just move the mouse 1px up and down, scrollDirection will be empty,
             * if that is the case, we don't want to trigger pin event
             */
            if (scrollDistance > 0) {
                scrollDirection = 'down';
            } else if (scrollDistance < 0) {
                scrollDirection = 'up';
            }

            if ('' !== scrollDirection) {
                this.triggerScroll(scrollDirection, scrollYpos);
            }

            this.cachedScrollYpos = scrollYpos;

        }
    }

}

export default new BannerAdsPin();


// WEBPACK FOOTER //
// ./assets/components/ads/BannerAdsPin.js